import AppHeader from "@/components/AppHeader";
import dynamic from "next/dynamic";
import { FC, ReactNode } from "react";
import { Poppins } from 'next/font/google';

const poppins = Poppins({ weight: ['400', '500', '700'], subsets: ['latin'] });

const Layout: FC<{ children?: ReactNode }> = ({ children }) => {
  return (
    <main className={`${poppins.className}`}>
      <AppHeader />
      <div className="md:px-10 lg:px-40">
        {children}
      </div>
    </main>
  );
};

const DynamicLayout = dynamic(() => Promise.resolve(Layout), {
  ssr: false,
});

export default DynamicLayout;